/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function() {

  var pro_length = $(document).find('.PwzrGrid-direction-xs-column').length;
 // console.log('pro_length:'+pro_length);
  $(document).on("click",".product_metafields_image",function() {
      $('.product_metafields_image').removeClass('custom_active');
      $('span.classics_name.addclass').removeClass('addclass');
      $(this).addClass('custom_active');
      $(this).closest(".bolcks_box").find("span.classics_name").addClass('addclass');
     // var text = $(this).closest(".product_metafields_image.custom_active").find(".Variant_text").text();
      var thstext = $(this).attr('data-text');
      $(".classics_name.addclass").text(thstext);
       $('.PwzrGrid-direction-xs-column-115 > div > div').each(function(){
         var findname = $(this).attr('data-option-value');
         if(findname == thstext){
          // $(this).click();
            $(this).trigger('click')
         }
      });
     $('.PwzrGrid-direction-xs-column-233 > div > div').each(function(){
         var findname = $(this).attr('data-option-value');
         if(findname == thstext){
          // $(this).click();
            $(this).trigger('click')
         }
      });
  });

  
function LoopForever() {
  $(document).find('.PwzrGrid-wrap-xs-nowrap-118').hide();
  $(document).find('.PwzrGrid-wrap-xs-nowrap-130').hide();
}
var interval = self.setInterval(function(){LoopForever()},500);
  
});